import { render } from "./BlogPreview.vue?vue&type=template&id=3263e9f8"
import script from "./BlogPreview.vue?vue&type=script&lang=js"
export * from "./BlogPreview.vue?vue&type=script&lang=js"

import exportComponent from "/builds/dalmadima/umzugbayernwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__